<div class="flex items-center justify-center px-4 py-8 lg:py-12">
  <div class="p-8 max-w-xl w-full rounded-lg shadow-md border border-[#F3F4F6] text-center space-y-8">

    <div class="flex justify-center">
      <div class="w-48 h-48 md:w-64 md:h-64 flex items-center justify-center">
        <img [src]="imageSrc()" alt="Status" class="max-w-full h-auto object-contain">
      </div>
    </div>

    <div class="space-y-4">
      <h1 class="text-2xl font-semibold text-[#0D3543]">
        {{ title() }}
      </h1>
      <p class="text-[#6C737F] text-sm font-normal md:text-base leading-relaxed max-w-xl mx-auto">
        {{ description() }}
      </p>
    </div>

    <div class="flex flex-col md:flex-row items-center justify-center gap-6 pt-4 w-full">

      @if (secondaryBtnLabel()) {
        <a [routerLink]="secondaryBtnLink()"
           class="flex-1 w-full flex items-center justify-center gap-2 text-gray-700 font-medium rounded-lg hover:text-gray-900 transition-colors border border-gray-100 py-3">
          <sham-i-home-03 />
          {{ secondaryBtnLabel() }}
        </a>
      }

      <button (click)="primaryAction.emit()"
              class="flex-1 w-full py-3 bg-[#2596BE] hover:bg-[#1a7a9c] text-base text-[#FFFFFF] rounded-lg font-normal transition-all shadow-lg shadow-sky-100">
        {{ primaryBtnLabel() }}
      </button>

    </div>
  </div>
</div>
